module.exports = __webpack_public_path__ + "img/B20-20190415_02.1afe6d11.jpg";